<template>
  <div>
    <div class="renewing-membership membership-options">
      <div class="row">
        <div class="col-md-12 ">
          <h6>
            {{ configOptions['renewal-label-additional-contribution'] }}
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content" v-html="configOptions['renewal-info-additional-contribution']"></div>
              <i class="fas fa-info-circle" title=""></i>
            </el-tooltip>
          </h6>
          <p class="font-weight-light" v-html="configOptions['renewal-additional-contribution']"></p>
          <el-form class="donation-settings" @submit.native.prevent>
            <el-alert
              :title="amountError.message"
              type="error"
              show-icon
              v-show="amountError.show"
              @close="amountError = false"
            />

            <el-button-group class="toggle-options w-50" v-if="donationOptions['allow-monthly-donation']">
              <el-button :type="AllowMonthlyDonation ? 'plain' : 'primary'" @click="toggleFrequency('once')">Once Only</el-button>
              <el-button :type="AllowMonthlyDonation ? 'primary' : 'plain'" @click="toggleFrequency('monthly')" v-if="donationOptions['allow-monthly-donation']">Monthly</el-button>
            </el-button-group>

            <div class="d-flex">
              <div class="flex-fill select-amount-box">
                <p>Select amount</p>
                <el-radio-group
                v-model.lazy="donationAmount"
                @change="onSelectAmount" size="medium">
                  <el-radio
                    v-for="(gift, i) in getAmountLists"
                    :label="typeof gift === 'object' ? '$' + gift['gift-amount'] : '$' + gift"
                    :key="i"
                    border
                  >
                  </el-radio>
                </el-radio-group>
              </div>
              <div class="align-self-center mx-4 text-primary">Or</div>
              <div class="flex-fill custom-amount-box">
                <p>Choose your own amount</p>
                <el-form-item class="custom-input">
                  <img class="dollar-sign" src="../../assets/icons/dollar.svg" alt="">
                  <el-input v-model.number="customAmount" placeholder="Enter amount"/>
                </el-form-item>
              </div>
            </div>
          </el-form>
          <el-checkbox v-model="eligibleChecked">
            <span v-html="donationOptions['eligibility-text-individual']" />
            <a href="#" class="font-weight-bold" @click="disclosureState = true">Disclosure statement</a>
          </el-checkbox>
        </div>
      </div>
      <div v-if="showRemoveButton">
        <el-link icon="el-icon-error" :underline="false" type="danger" @click="clearDonation">Remove donation</el-link>
      </div>
    </div>
    <el-dialog class="dialog-popup" :visible.sync="disclosureState">
      <div v-html="donationOptions['disclosure-content']" />
    </el-dialog>
    <div class="renewal-btn d-flex flex-wrap">
      <el-button type="secondary" @click="setStep(1)"><i class="el-icon-back"></i> BACK</el-button>
      <el-button type="primary" @click="onSubmit">NEXT <i class="el-icon-arrow-right el-icon-right"></i></el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      AllowMonthlyDonation: false,
      amountError: { show: false, message: "" },
      donationAmount: "",
      customAmount: "",
      eligibleChecked: false,
      disclosureState: false
    };
  },
  watch: {
    customAmount(val) {
      if(val > 0) {
        this.donationAmount = '';
        this.validateCustomAmount();
      } else {
        this.amountError.show = false;
      }
    },
    donationAmount() {
      this.customAmount = '';
    }
  },
  computed: {
    ...mapGetters('renewal', ['configOptions', 'donationOptions', 'donation']),
    getAmountLists() {
      return this.donationOptions['gift-array']
    },
    showRemoveButton() {
      return this.donation.amount > 0 || this.donationAmount !== '' || this.customAmount !== '';
    }
  },
  mounted() {
    this.AllowMonthlyDonation = this.donation.monthly;
    if (this.donation.amount > 0) {
      if (this.donation.custom) {
        this.customAmount = this.donation.amount;
      } else {
        this.donationAmount = `$${this.donation.amount}`;
      }
    }
  },
  methods: {
    ...mapMutations('renewal', ['setStep', 'setPayload']),
    onSubmit() {
      this.amountError.show = false;
      if (this.customAmount || this.donationAmount) {
        if(!this.eligibleChecked) {
          this.amountError.show = true;
          this.amountError.message = "You must approve the disclosure statement";
        }
      }

      if (!this.amountError.show) {
        this.nextStep();
      }
    },
    toggleFrequency(frequency) {
      if (frequency === "once") {
        this.AllowMonthlyDonation = false;
      } else if (frequency === "monthly") {
        this.AllowMonthlyDonation = true;
      }
    },
    onSelectAmount() {
      this.amountError.show = false;
    },
    clearDonation() {
      this.donationAmount = '';
      this.customAmount = '';
      this.AllowMonthlyDonation = false;
      this.setPayload({
        donation: {
          ...this.donation,
          amount: 0,
          monthly: this.AllowMonthlyDonation,
          custom: false
        }
      });
    },
    saveDonation() {
      const amount = this.donationAmount !== '' ? this.donationAmount.substring(1) : this.customAmount;
      if (amount !== '') {
        this.setPayload({
          donation: {
            ...this.donation,
            amount: Number.parseInt(amount, 10),
            monthly: this.AllowMonthlyDonation,
            custom: this.donationAmount === ''
          }
        });
      }
    },
    validateCustomAmount() {
      if(this.$isNum(this.customAmount)) {
        if (this.customAmount > this.donationOptions["maximum-donation"]) {
          this.amountError.message = this.donationOptions["validation-donation-form"]["invalid-donation-too-high"];
          this.amountError.show = true;
        } else if (this.customAmount < this.donationOptions["minimum-donation"] || this.customAmount < 0) {
          this.amountError.message = "Your donation is lesser than the minimum allowed";
          this.amountError.show = true;
        } else {
          this.amountError.show = false;
        }
      } else {
        this.amountError.message = "Must input a number";
        this.amountError.show = true;
      }
    },
    nextStep() {
      this.saveDonation()
      this.setStep(3);
    }
  }
}
</script>

<style lang="scss" scoped>
.select-amount-box {
  width: 60%;
}

.select-amount-box, .custom-amount-box {
  p {
    font-weight: 600;
  }
}

.custom-input {
  img {
    z-index: 2;
  }

  >>>.el-input {
    .el-input__inner {
      height: 56px!important;
      padding-left: 30px;
      font-size: 20px!important;
    }
  }
}

.dollar-sign {
  position: absolute;
  top: 19px;
  left: 10px;
  width: 11px;
}

.label {
  font-size: 14px;
}

ul li, h1,h2,h3,h4,h5, p, a, span,label {
  font-family: 'Gotham Narrow Book', sans-serif;
}

.donation-settings {
  @media screen and (max-width: 767px) {
    margin-bottom: 1.5rem;
  }

  p {
    margin-bottom: 0.5rem;
  }

  .el-alert {
    margin-bottom: 10px;
  }

  .el-button-group {
    display: flex;
    margin: 16px 0;
  }

  .next-btn {
    margin-top: 20px;
  }

  .el-button {
    width: 100%;
  }

  .el-radio-group {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;

    >>>.el-radio__input {
      margin-top: 2px;
    }

    >>>.el-radio__label {
      font-size: 20px;
    }
  }

  .el-radio.is-bordered + .el-radio.is-bordered,
  .el-radio.is-bordered {
    margin: 0;
    margin-bottom: 16px;
    width: calc(100% / 4 - 10px);
  }

  .el-radio--medium.is-bordered {
    height: 56px;
    padding: 10px 20px 10px 10px;

    display: flex;
    align-items: center;
  }

  .el-radio.is-bordered.is-checked {
    background: rgba(4, 173, 238, 0.05);

    >>>.el-radio__label {
      font-weight: bold;
      color: #00529b;
    }
  }
}

.el-checkbox {
  >>>.el-checkbox__input {
    line-height: 2;
  }

  >>>.el-checkbox__label {
    font-weight: 600;
  }
}

.el-link {
  &.el-link--danger {
    color: #F56C6C;
    border-bottom-color: transparent;
  }
}
</style>
